import type { ClassValue } from 'clsx'

import { clsx } from 'clsx'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function handleError(error: import('axios').AxiosError, fallBackMessage?: string) {
  toast.dismiss()
  const errorMessage
    = (error?.response?.data as { message?: string })?.message || fallBackMessage
  toast.error(errorMessage)
};
